import { render, staticRenderFns } from "./WinLoseLog.vue?vue&type=template&id=c82ec778&scoped=true"
import script from "./WinLoseLog.vue?vue&type=script&lang=ts"
export * from "./WinLoseLog.vue?vue&type=script&lang=ts"
import style0 from "./WinLoseLog.vue?vue&type=style&index=0&id=c82ec778&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c82ec778",
  null
  
)

export default component.exports